import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'tooltip-info',
    templateUrl: './tooltip-info.component.html',
    styleUrls: ['./tooltip-info.component.scss'],
    host: {
        class: 'tooltip-info'
    },
    standalone: false
})
export class TooltipInfoComponent implements OnInit {

  @Input() tooltipText: string = '';
  @Input() imageUrl: string = '';
  @Input() imageAlt: string = '';

  showTooltip: boolean = false;
  isTouchDevice: boolean = false;
  private touchTimeout: any;

  ngOnInit() {
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  onMouseEnter() {
    if (!this.isTouchDevice) {
      this.showTooltip = true;
    }
  }

  onMouseLeave() {
    if (!this.isTouchDevice) {
      this.showTooltip = false;
    }
  }

  onTouch(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showTooltip = !this.showTooltip;
  }

  onTouchStart(event: TouchEvent) {
    if (this.isTouchDevice) {
      event.preventDefault();
    }
  }

  closeTooltip() {
    this.showTooltip = false;
  }
}
